import { loan_application, person } from '@axo/shared/data-access/types';
import { UseQueryResult } from 'react-query';

export function getApplicationTabLabel(
  detail: UseQueryResult<loan_application.LoanApplication>,
  person: UseQueryResult<person.Person>
) {
  if (person.data?.LastName) {
    return `${person.data.FirstName?.slice(0, 1)}. ${person.data.LastName}`;
  }

  if (detail.data?.HumanReadableID) {
    return `${detail.data?.HumanReadableID.slice(-5)}`;
  }

  return undefined;
}
